import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/admin/crm/leads"; 
const apiFeedBackEndPoint=API_BASE_URL_ENV() + "/admin/crm/feedbacks"; 
const apiBulkUpdateEndPoint=API_BASE_URL_ENV() + "/admin/crm/leads-bulk-update"; 
const apiDropDownEndpoint= API_BASE_URL_ENV() + "/admin/crm/dropdown/Lead"
const apiAssignSalesRep= API_BASE_URL_ENV() + "/admin/crm/assign-sales-rep"
export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }
 
    addFeedback=(data)=>{
        return http.post(apiFeedBackEndPoint, data);
    }
    updateMultiLead=(data)=>{
        return http.post(apiBulkUpdateEndPoint, data);
    }
    getDropDown=()=>{
        return  http.get(apiDropDownEndpoint) 
    }

    assignSalesRep=(data)=>{
        return http.post(apiAssignSalesRep, data);
    }
}
